module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/martin_sachs.jpg";